<template>
  <div>
    <a
      v-if="!archived"
    >
      <v-icon
        v-if="!deleting"
        small
        color="red"
        @click="deleting=true"
      >
        delete_outline
      </v-icon>
      <v-icon
        v-else
        class="shake"
        color="red"
        @click="$emit('archive')"
      >
        delete_forever
      </v-icon>
    </a>
    <a
      v-else
    >
      <v-icon
        small
        color="green"
        @click="$emit('restore')"
      >
        restore
      </v-icon>
    </a>
  </div>
</template>

<script>
export default {
  props: ['archived'],
  data () {
    return {
      deleting: false
    }
  },
  watch: {
    deleting () {
      if (this.deleting) {
        setTimeout(() => {
          this.deleting = false
        }, 15000)
      }
    }
  }
}
</script>

<style>
.shake {
  text-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  animation-name: shaken;
  animation-delay: -0.75s;
  animation-duration: .25s;
  animation-iteration-count: infinite;
  transform-origin: 50% 10%;
}

@keyframes shaken {
    0% {
        transform: rotate(-3deg);
        animation-timing-function: ease-in;
    }
    50% {
        transform: rotate(3.5deg);
        animation-timing-function: ease-out;
    }
}
</style>
